module.exports = __webpack_public_path__ + "assets/cross-0fb7ba.svg";